/*
 * ES6 Babel必須
 * ポリフィルも必須
 * <script src="https://polyfill.io/v2/polyfill.min.js?features=IntersectionObserver"></script>
 */
export default (APP) => {
  /* ターゲット要素 */
  const targets = document.querySelectorAll('[data-scroll]')

  /*
   * https://blog.jxck.io/entries/2016-06-25/intersection-observer.html
   */
  const config = {
    root: null,
    rootMargin: '30px 0px',
    threshold: calcThresholds(0)
  }

  /**
   * thresholdのステップを計算
   */
  function calcThresholds (numSteps) {
    const thresholds = []

    for (let i = 1.0; i <= numSteps; i++) {
      var ratio = i / numSteps
      thresholds.push(ratio)
    }

    thresholds.push(0)
    return thresholds
  }

  /**
   * 文字列から配列に変換し、オプションのオブジェクトを生成する
   * @param  {object} option 設定情報
   */
  function createOptionObj (data) {
    // カンマ区切りでまずは配列に変換
    const dataArray = data.split(',')

    const result = {}
    const length = dataArray.length

    // オブジェクトにプロパティをセットする
    for (let i = 0; i < length; i++) {
      const property = dataArray[i].split(':')
      result[property[0]] = property[1]
    }

    return result
  }

  /*
   * インスタンス・イベント登録
   */
  // const innerHeight = window.innerHeight
  const observer = new window.IntersectionObserver(callback, config)
  Array.prototype.forEach.call(targets, $target => {
    init($target) // 初期化
    observer.observe($target)
  })

  /*
   * 処理：scroll
   */
  function callback (entries, observer) {
    entries.forEach(entry => {
      const $target = entry.target

      if (!entry.isIntersecting) return

      observer.unobserve($target) // 1度だけ実行

      processing($target)
    })
  }

  function init ($target) {
    // 準備完了
    $target.classList.add('scroll-ready')

    // ターゲットごとのオプションを取得し、デフォルトとマージ
    const option = $target.getAttribute('data-scroll-option')
    const setOption = (option) ? createOptionObj(option) : {}

    /**
     * 記述例
     const defaultOption = {
       transitionDelay: '0s',
       transitionDuration: '1.0s',
       transitionTimingFunction: 'ease'
     }
     */
    const defaultOption = {}

    const config = APP.ex.extend({}, defaultOption, setOption)

    if (APP.ex.type(config) === 'object' && Object.keys(config).length) {
      /* .scroll-readyのスタイルを確実に設定するため遅延 */
      setTimeout(function () {
        /* CSS設定 */
        for (const key in config) {
          $target['style'][key] = config[key]
        }
      }, 0)
    }

    /* data属性削除 */
    $target.removeAttribute('data-scroll-option')
  }

  /*
   * ②可視状態の処理
   */
  function processing ($target) {
    $target.classList.remove('scroll-ready') // 発火

    $target.classList.add('scroll-visibled') // 発火

    /* 関数実行 */
    const fnName = $target.getAttribute('data-scroll')

    switch (fnName) {
      case 'test':
        doTest($target)
        break

      default:
        doDefault($target, fnName)
        break
    }
  }

  /*
   * --------- テスト
   */
  // テスト
  function doTest ($target) {
    console.log('data-scroll:test')
  }

  function doDefault ($target, name) {
    $target.classList.add(`data-scroll--${name}`) // 発火
  }
}
